import { render, staticRenderFns } from "./NeskladjaIPVsa.vue?vue&type=template&id=f980274a&"
import script from "./NeskladjaIPVsa.vue?vue&type=script&lang=js&"
export * from "./NeskladjaIPVsa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports